import { environment } from './../environments/environment';
import { makeEnvironmentProviders } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

// TODO remove deploy URL
export const provideBaseHref = () =>
  makeEnvironmentProviders([
    {
      provide: APP_BASE_HREF,
      useValue: environment.deployUrl,
    },
  ]);
